module.exports = __webpack_public_path__ + "img/24.911f2b5b.png";